// Fixed spam patterns - more reliable word matching
export const spamPatterns = [
    /(?:^|\s)(fraud|fruad|recent transaction|recent transection|Bank of Amercia|Bank of Ameria|Bank of Americ|Bnk of America|Bank of Amerca|Bank of Americaa|Click here to verify|Click here for verify|Access your account now|Payment declined|transaction declined|transection declined|Verify payment method|Verify your payment method|click to see important message|click here to see important message)(?:\s|$|[.,!?])/gi,
];

// High-risk keywords that trigger immediate block
export const highRiskKeywords = [/\bBank of America\b/gi];

// Whitelist for legitimate domains that should never be flagged
export const legitimateDomains = [
    /microsoft\.com/i,
    /microsoft\.co/i,
    /teams\.microsoft/i,
    /office\.com/i,
    /sharepoint\.com/i,
    /\bbit\.ly\b/i,
    /\btinyurl\.com\b/i,
];

// More refined spam domains - separate legitimate shorteners from suspicious ones
export const suspiciousShorteners = [/\bt\.co\b/i, /\bgoo\.gl\b/i, /\bow\.ly\b/i];

export const UNIVERSAL_SPAM_WARNING =
    "Warning: This account is not enabled for promotional messaging. Please contact support for assistance.";

// Enhanced URL detection function
export function detectAndValidateUrls(text) {
    var urlRegex = /(https?:\/\/[^\s<>"{}|\\^`[\]]+)/gi;
    var urls = text.match(urlRegex) || [];
    var urlAnalysis = {
        totalUrls: urls.length,
        spamUrls: [],
        legitUrls: [],
        suspiciousUrls: [],
        spamScore: 0,
    };

    if (urls.length === 0) {
        return urlAnalysis;
    }

    urls.forEach(function (url) {
        var urlScore = 0;
        var urlStatus = "unknown";

        // Check if URL is from a legitimate domain first
        var isLegitimate = legitimateDomains.some(function (pattern) {
            return pattern.test(url);
        });

        if (isLegitimate) {
            urlAnalysis.legitUrls.push(url);
            return; // Skip further checks for whitelisted domains
        }

        // Check for suspicious shorteners (separate from legitimate ones)
        var isSuspiciousShortener = suspiciousShorteners.some(function (pattern) {
            return pattern.test(url);
        });

        if (isSuspiciousShortener) {
            urlScore += 15; // Lower score for suspicious shorteners
            urlStatus = "suspicious";
        }

        // Check for phishing indicators in URL
        if (hasPhishingIndicators(url)) {
            urlScore += 40;
            urlStatus = "spam";
        }

        // Categorize URL based on score
        if (urlScore >= 50 || urlStatus === "spam") {
            urlAnalysis.spamUrls.push(url);
        } else if (urlScore >= 15) {
            urlAnalysis.suspiciousUrls.push(url);
        } else if (urlStatus !== "legitimate") {
            urlAnalysis.suspiciousUrls.push(url);
        }

        urlAnalysis.spamScore += urlScore;
    });

    return urlAnalysis;
}

// Helper function to detect phishing indicators
export function hasPhishingIndicators(url) {
    var phishingPatterns = [
        // Common phishing domain typos
        /bankofamer[1i]ca/i,
        /we11sfargo/i,
        /paypa1/i,
        /app1e/i,
        /m1crosoft/i,
        /arnazon/i,
        // Homograph attacks (similar looking characters)
        /аpple/i, // Cyrillic 'а' instead of 'a'
        /miсrosoft/i, // Cyrillic 'с' instead of 'c'
        // Suspicious paths (only flag if combined with suspicious domains)
        ///login|signin|verify|update|secure|account/i
    ];
    return phishingPatterns.some(function (pattern) {
        return pattern.test(url);
    });
}

const toggleSendButtons = (show) => show;

// Fixed detectSpamPatterns function with proper state management
export function detectSpamPatterns(text) {
    var spamScore = 0;

    // Input validation
    if (!text || typeof text !== "string") {
        toggleSendButtons(true);
        return { score: 0, buttonShow: true };
    }

    if (text.length < 10) {
        toggleSendButtons(true);
        return { score: 0, buttonShow: true };
    }

    // Reset all regex patterns to avoid state issues
    spamPatterns.forEach(function (pattern) {
        pattern.lastIndex = 0;
    });

    highRiskKeywords.forEach(function (pattern) {
        pattern.lastIndex = 0;
    });

    // Check for high-risk keywords first - immediate block
    var highRiskDetected = false;
    for (var i = 0; i < highRiskKeywords.length; i++) {
        highRiskKeywords[i].lastIndex = 0; // Reset before each test

        if (highRiskKeywords[i].test(text)) {
            highRiskDetected = true;
            spamScore = 100;
            break; // Exit immediately on first match
        }
    }

    if (highRiskDetected) {
        toggleSendButtons(false);
        return {
            score: spamScore,
            buttonShow: false,
        };
    }

    // Continue with other checks only if no high-risk detected
    var urlAnalysis = detectAndValidateUrls(text);

    if (urlAnalysis.spamUrls.length > 0) {
        spamScore += 50;
    }

    if (urlAnalysis.suspiciousUrls.length > 0) {
        spamScore += 15;
    }

    if (urlAnalysis.totalUrls > 3) {
        spamScore += 20;
    }

    spamScore += urlAnalysis.spamScore;

    // FIXED: Check spam word patterns with better logging
    spamPatterns[0].lastIndex = 0; // Reset before use
    var matches = text.match(spamPatterns[0]) || [];
    var spamWordMatches = matches.length;

    // CHANGED: Trigger warning on 1 or more spam words (was > 1, now >= 1)
    if (spamWordMatches > 0) {
        spamScore += spamWordMatches * 8; // Each additional word adds more score
    }

    var buttonShow = spamScore > 0 ? false : true;
    toggleSendButtons(buttonShow);

    return {
        score: spamScore,
        buttonShow: buttonShow,
    };
}
